<template>
  <div class="current-font">
    <brand-menu></brand-menu>
    <div class="user">
    	<div class="container">
    		<div class="center-box">
    				<div class="title f_spec-B"><h1>Reset Password</h1></div>
    				  <form role="form" class="form-box clearfix">
    					  <p>Please specify your email address and then click on "Reset password". You will then receive an email with which you can change your password.
    <br><br><br></p>
    					  <p> </p>
    					  <div class="form-group">
    						<label for="first-name">Email Address*</label>
    						<input type="text" class="form-control" v-model="form.email">
    					  </div>
    					  <div class="form-group">
    						<!-- <a href="#">Forgot your password?</a> -->
    					  </div>
    					  <div class="form-group text-right">

    						<input type="button" class="btn btn-lg btn-blue" value="Sumbit" @click="handleResetPwd">
    				    </div>
    				</form>
    			<p class="text-center">
            <a href="javascript:;" @click="handleBack">BACK</a>
            <br><br><br><br><br><br><br><br><br>
          </p>
    		</div>
    	</div>

    </div>
  </div>
</template>

<script>
import BrandMenu from "@/components/BrandMenu";
import { validateEmail } from "@/utils/validate.js"
import {resetPassword} from '@/api/userProfile'
export default {
  name: "ResetPasswordView",
  components: {
    BrandMenu
  },
  data() {
    return {
      form: {
        email: undefined,
        basePath: undefined
      },
    }
  },
  created() {
    // 获取当前页面地址，如http://localhost:8080/admin/index
    let wPath = window.document.location.href;
    // 获取当前页面主机地址之后的目录，如：/admin/index
    let pathName =  this.$route.path;
    let pos = wPath.indexOf(pathName);
    // 获取主机地址，如：http://localhost:8080
    let localhostPath = wPath.substring(0, pos);
    this.form.basePath = localhostPath;
  },
  methods: {
    handleResetPwd() {
      if (!this.form.email.trim()) {
        this.error('必填字段，不能为空')
        return
      }
      if (!validateEmail(this.form.email)) {
        this.error('无效的email')
        return
      }
      resetPassword(this.form).then(response => {
        this.success('更新成功')
      }).catch(error => {
        this.error('更新失败')
      })


    },
    handleBack() {
      this.$router.back(-1)
    },
    error(msg) {
      this.$message({
        message: msg,
        type: 'error',
        offset: 80
      })
    },
    success(msg) {
      this.$message({
        message: msg,
        type: 'success',
        offset: 80
      })
    },
  }
}
</script>

<style scoped>
  @import url('../assets/xh/css/user.css');

  input[type="text"] {
    font-family: SourceHanSansCN-ExtraLight;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/views/ResetPasswordView.vue